<mat-card>
  <canvas id="canvas" width="700" height="400"></canvas>
</mat-card>



// WEBPACK FOOTER //
// /Users/cwseger/go/src/github.com/cwseger/travel-time-ui/src/app/components/chart/chart.component.html